import React from 'react';
import { Grid, Card, CardHeader, CardContent } from '@mui/material';
import { Translate } from 'react-localize-redux';
import { useInvestigationComparison } from '../../hooks/useInvestigationComparison';
import InvestigationComparisonTable from '../../InvestigationComparisonTable';

interface StudiesTabProps {
    startDate?: number | null;
    endDate?: number | null;
}

// SKIN-273 — cross-investigation comparison. Gated by FUNCTIONALITY.CLINICAL
// (same as Clinical tab). Shows investigations the API returns for the caller.
const StudiesTab: React.FC<StudiesTabProps> = ({ startDate = null, endDate = null }) => {
    const { data, loading, error, retry } = useInvestigationComparison(startDate, endDate);

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Card>
                    <CardHeader title={<Translate id="hospital.analytics.studies.title" />} />
                    <CardContent>
                        <InvestigationComparisonTable
                            loading={loading}
                            error={error}
                            rows={data}
                            onRetry={retry}
                        />
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    );
};

export default StudiesTab;
